import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const discountAPI = axios.create({
  baseURL: `${API_BASE_URL}/first-reservation-discount`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

discountAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('First Reservation Discount Service Error:', error);
    return Promise.reject(error);
  }
);

export const firstReservationDiscountService = {
  // Obtener la configuración global (público)
  getConfig: async () => {
    try {
      const response = await discountAPI.get('/');
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener configuración de descuento: ' + error.message);
    }
  },

  // Verificar elegibilidad del usuario actual (requiere auth)
  checkEligibility: async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await discountAPI.get('/check-me', {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      return response.data;
    } catch (error) {
      throw new Error('Error al verificar elegibilidad: ' + error.message);
    }
  },
};

export default firstReservationDiscountService;
